import { Component, EventEmitter, Output } from '@angular/core'

@Component({
  selector: 'app-column-edit-control',
  templateUrl: './column-edit-control.component.html',
  styleUrls: ['./column-edit-control.component.scss'],
})
export class ColumnEditControlComponent {
  @Output() select = new EventEmitter<boolean>()

  onClick() {
    this.select.emit(true)
  }
}
